import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseEstablishmentBillsProps<T> = {
  filters: {
    search?: string
    page?: number
    establishmentId?: string
    status?: string
    startDate?: string
    endDate?: string
  }
  mapper?: (data: any) => T
}

export const useEstablishmentBills = <T,>({
  filters: { search, page, establishmentId, status, startDate, endDate },
  mapper = Mapper.default<T>(),
}: UseEstablishmentBillsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['establishmentBills', search, page, establishmentId, status, startDate, endDate],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/establishment_bills`, {
        params: {
          search,
          page,
          'q[company_id_eq]': establishmentId,
          'q[status_eq]': status,
          'q[opened_at_gteq]': startDate,
          'q[closed_at_lteq]': endDate,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
